// Centralised site configuration for Fortuna Strive.
// Placeholders are intentionally left as clearly-labeled values until real data is supplied.

export const site = {
  companyLegalName: "FORTUNASTRIVE SERVICES PRIVATE LIMITED",
  brandName: "Fortuna Strive",
  tagline: "Strategy. Systems. Scale.",
  domain: "https://fortunastrive.com",
  secondaryDomain: "https://fortunastriveservices.com",
  contactEmail: "info@fortunastrive.com",
  emailDomain: "@fortunastrive.com",

  // Corporate registration (verified, exact)
  cin: "U62099WB2024PTC267861",
  incorporationDate: "24 January 2024",
  registeredOffice:
    "Suryatoron Apt, Ground Floor, Flat A, Mahisya Para, Khardah, Barrackpore, North 24 Parganas – 700117, West Bengal, India",
  countryOfIncorporation: "India",

  // Official contact details
  phone: "+91 6290212945",
  bookingUrl: "https://calendly.com/kenzoommeeting/strategy-session",
  social: {
    instagram: "https://www.instagram.com/kenr_dm/",
    facebook: "https://www.facebook.com/ken.kushal.rao",
  },

  // Analytics intentionally empty (no trackers loaded until IDs supplied)
  analytics: {
    ga4: "",
    metaPixel: "",
  },
};

export const nav = [
  { label: "Services", to: "/services" },
  { label: "Approach", to: "/approach" },
  { label: "Work", to: "/work" },
  { label: "Framework", to: "/framework" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];
